var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Dropdown } from "../Dropdown";
import { getTrials } from "../../../utils/api/trials/dataAccess";
export const TrialDropdown = ({ value, onChange, disabled = false }) => {
    const [trials, setTrials] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState("");
    useEffect(() => {
        const fetchTrials = () => __awaiter(void 0, void 0, void 0, function* () {
            const apiResponse = yield getTrials(true);
            if (apiResponse.status === 200 && apiResponse.data) {
                const trialsWithYear = apiResponse.data.map((trial) => {
                    return Object.assign(Object.assign({}, trial), { NameWithTrialYear: `${trial.trialCode} - ${trial.name.trim()} (${trial.trialYear})` });
                });
                //sort by NameWithTrialYear
                trialsWithYear.sort((a, b) => a.NameWithTrialYear.localeCompare(b.NameWithTrialYear));
                setTrials(trialsWithYear);
            }
        });
        fetchTrials();
    }, []);
    //================================================================================================
    // FUNCTIONS
    //================================================================================================
    const handleOnChange = (value) => {
        setSelectedCategory(value !== null && value !== void 0 ? value : '');
        //from trials we will get a min-max values, pass them back as a number array
        if (value) {
            const selectedTrial = trials.find(trial => trial.id === value);
            if (selectedTrial) {
                onChange(selectedTrial.id, [selectedTrial.name]);
            }
            else {
                onChange(null, []);
            }
        }
        else {
            onChange(null, []);
        }
    };
    return (React.createElement(Dropdown, { items: trials, displayName: "NameWithTrialYear", displayValue: "id", label: "Trials", value: selectedCategory, onChange: handleOnChange, labelPosition: "top", disabled: disabled }));
};
